import {
  COMPLIANCE_CHANGESET_GET_CHANGESET,
  COMPLIANCE_CHANGESET_GET_CHANGESET_SUCCESS,
  COMPLIANCE_CHANGESET_GET_CHANGESET_FAIL,
  COMPLIANCE_CHANGESET_GET_CHANGESET_CLEAR,
} from './types';

export const initialState = {
  loading: false,
  data: {},
};

const reducer = (state = initialState, action) => {
  const { type } = action;
  switch (type) {
    case COMPLIANCE_CHANGESET_GET_CHANGESET: {
      return {
        ...state,
        loading: true,
        data: {},
      };
    }
    case COMPLIANCE_CHANGESET_GET_CHANGESET_SUCCESS: {
      const { data } = action.payload;
      return {
        loading: false,
        data,
      };
    }
    case COMPLIANCE_CHANGESET_GET_CHANGESET_FAIL: {
      return {
        ...state,
        loading: false,
        data: {},
      };
    }
    case COMPLIANCE_CHANGESET_GET_CHANGESET_CLEAR: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default reducer;
